import { Component, Inject, ViewChild, viewChild } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SalesOrderService } from '../../features/salesOrder/services/salesOrder.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule, DatePipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { EmployeeService } from '../../features/employees/employee.service';
import { ProjectService } from '../../features/projects/services/projects.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ActionTypeEnum } from '../../../assets/enum/actionTypeEnum';
import { CdkAutofill } from "@angular/cdk/text-field";
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';
@Component({
  selector: 'app-order-flow-admin-view',
  standalone: true,
  imports: [MatExpansionModule, MatMenuModule, DatePipe, CommonModule, CdkAutofill],
  templateUrl: './order-flow-admin-view.component.html',
  styleUrl: './order-flow-admin-view.component.scss',
})
export class OrderFlowAdminViewComponent {
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private salesOrderService: SalesOrderService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private employeeService: EmployeeService,
    private permissionService: PermissionService
  ) {}

  readonly menuTrigger = viewChild.required(MatMenuTrigger);
  salesOrderId: any;
  orderData: any = {};
  inProgressData: any;
  orderServiceData: any;
  isLoading: boolean = false;
  actorId: any;
  canTimelineSalesOrder$ = this.permissionService.hasPermission(
      ModuleIds.SalesOrder,
      'Timeline'
    );
    canUnassignSalesOrder$ = this.permissionService.hasPermission(
      ModuleIds.SalesOrder,
      'Unassign'
    );
    canAssignReassignSalesOrder$ = this.permissionService.hasPermission(
      ModuleIds.SalesOrder,
      'Assign/Reassign'
    );
    canCompletedSalesOrder$ = this.permissionService.hasPermission(
      ModuleIds.SalesOrder,
      'Completed'
    );

  ngOnInit(): void {
    const loggedInUser: any = localStorage.getItem('loggedInUser');
    const userData = JSON.parse(loggedInUser);
    this.actorId = userData?.employeeId;

    this.route.queryParamMap.subscribe((queryParams) => {
      this.salesOrderId = queryParams.get('id');
      if (this.salesOrderId) {
        const id = +this.salesOrderId;
        this.fetchOrderById(id);
        this.getAllInProgressServiceTaskAssignmentsForAnOrder(id);
        this.orderServices('', id);
      }
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(OrderFlowDialog, {
      width: '500px',
      data: { id: this.salesOrderId },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getAllInProgressServiceTaskAssignmentsForAnOrder(
        Number(this.salesOrderId)
      );
      this.orderServices('', Number(this.salesOrderId));
    });
  }

  openDialogAssignee(id: any): void {
    const dialogRef = this.dialog.open(AssigneeDailog, {
      width: '500px',
      data: { id: id, status: status },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getAllInProgressServiceTaskAssignmentsForAnOrder(
        Number(this.salesOrderId)
      );
      this.orderServices('', Number(this.salesOrderId));
    });
  }

  onUnassign(id: any) {
    const updateServiceTaskAssignmentInput = {
      id: id,
      employeeId: null,
      deadline: null,
      startedAt: null,
    };
    const CreateTaskTimelineInput = {
      assignmentId: id,
      actorId: this.actorId,
      actionType: 'Unassigned',
      performerId: null,
      message: 'Task unassigned',
    };
    this.salesOrderService
      .modifyTaskAssignment(
        id,
        updateServiceTaskAssignmentInput,
        CreateTaskTimelineInput
      )
      .subscribe({
        next: (data) => {
          this.toastr.success('Successfully unassigned');
          this.getAllInProgressServiceTaskAssignmentsForAnOrder(
            Number(this.salesOrderId)
          );
          this.orderServices('', Number(this.salesOrderId));
        },
        error: (error: any) => {
          this.toastr.error(error?.message);
        },
      });
  }

  fetchOrderById(id: any) {
    this.salesOrderService.getSalesOrderById(Number(id)).subscribe({
      next: (data) => {
        this.orderData = data;
      },
      error: (error) => {
        if (error?.message === 'No match found') {
          this.router.navigate([`sales-order`]);
        }
      },
    });
  }

  getAllInProgressServiceTaskAssignmentsForAnOrder(orderId: any) {
    this.salesOrderService
      .getAllInProgressServiceTaskAssignmentsForAnOrder(orderId)
      .subscribe({
        next: (data) => {
          this.inProgressData = data;
        },
        error: (error) => {
          if (error?.message === 'No match found') {
            this.router.navigate([`sales-order`]);
          }
        },
      });
  }

  orderServices(search: any = '', orderId: any) {
    this.salesOrderService.orderServices(search, Number(orderId)).subscribe({
      next: (data) => {
        this.orderServiceData = data;
      },
      error: (error) => {
        if (error?.message === 'No match found') {
          this.router.navigate([`sales-order`]);
        }
      },
    });
  }

  allTasksCompleted(order: any): boolean {
    return order?.serviceTaskAssignments?.length > 0 &&
      order.serviceTaskAssignments.every(
        (task: any) => task?.serviceTaskStatus === 'Completed'
      );
  }

  allServicesCompleted(order: any): boolean {
    return order?.length > 0 &&
      order.every(
        (task: any) => task?.serviceStatus === 'Completed'
      );
  }
  


  markAsTaskCompleted(taskId: any) {
    const taskAssignmentId = Number(taskId);
    const updateServiceTaskAssignmentInput = {
      id: taskAssignmentId,
      serviceTaskStatus: 'Completed',
    };
    const CreateTaskTimelineInput = {
      assignmentId: taskAssignmentId,
      actionType: ActionTypeEnum.Completed,
      actorId: this.actorId,
      message: `Status changed from ${this.orderData?.serviceTaskStatus} to Completed`,
    };
    this.salesOrderService
      .modifyTaskAssignment(
        taskAssignmentId,
        updateServiceTaskAssignmentInput,
        CreateTaskTimelineInput
      )
      .subscribe({
        next: (data) => {
          this.toastr.success('Task successfully completed');
          this.orderServices('', this.salesOrderId);
        },
        error: (error: any) => {
          this.toastr.error(error?.message);
        },
      });
  }
  
  markServiceAsCompleted(serviceId: any) {
    this.salesOrderService
      .markAsCompletedAllServiceTaskAssignmentsForAnOrderService(
        Number(serviceId)
      )
      .subscribe({
        next: (data) => {
          this.toastr.success('Service successfully completed');
          this.orderServices('', this.salesOrderId);;
        },
        error: (error: any) => {
          this.toastr.error(error?.message);
        },
      });
  }


  onStatusChange(status: any) {
    const updateOrderInput = {
      id: Number(this.salesOrderId),
      status: status,
    }
    this.salesOrderService
      .updateOrder(Number(this.salesOrderId), updateOrderInput)
      .subscribe({
        next: (data) => {
          this.toastr.success('Status changed successfully');
          this.fetchOrderById(this.salesOrderId);
        },
        error: (error: any) => {
          this.toastr.error(error?.message);
        },
      })
  }

  markAllServiceAsCompleted() {
    this.salesOrderService
      .markAsCompletedAllServiceTaskAssignmentsForAnOrder(
        Number(this.salesOrderId)
      )
      .subscribe({
        next: (data) => {
          this.toastr.success('Order successfully completed');
          this.orderServices('', this.salesOrderId);
          this.fetchOrderById(this.salesOrderId);
          this.router.navigate([`sales-order`]);
        },
        error: (error: any) => {
          this.toastr.error(error?.message);
        },
      });
  }

}

@Component({
  selector: 'order-flow-dialog',
  templateUrl: './order-flow-dialog.html',
  styleUrl: './order-flow-admin-view.component.scss',
  imports: [
    DatePipe,
    CommonModule
  ],
  standalone: true
})
export class OrderFlowDialog {
  taskTimelineData: any;
  constructor(
    public dialogRef: MatDialogRef<OrderFlowDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private salesOrderService: SalesOrderService,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.taskTimelines();
  }

  taskTimelines() {
    const id = Number(this.data?.id);
    this.salesOrderService.getTaskTimelinesForAnOrder(id).subscribe({
      next: (data) => {
        this.taskTimelineData = data;
      },
      error: (error) => {
       this.toastr.error(error?.message);
      },
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  selector: 'assignee-dailog',
  templateUrl: './assignee-dailog.html',
  styleUrl: './order-flow-admin-view.component.scss',
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatDatepickerModule,
  ],
  standalone: true,
})
export class AssigneeDailog {
  constructor(
    public dialogRef: MatDialogRef<AssigneeDailog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private projectService: ProjectService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private salesOrderService: SalesOrderService
  ) {}

  employees: any;
  assignForm: FormGroup;
  actorId: any;

  ngOnInit() {
    this.loadEmployees();
    this.initForm();
  }

  initForm() {
    const loggedInUser: any = localStorage.getItem('loggedInUser');
    const userData = JSON.parse(loggedInUser);
    this.actorId = userData?.employeeId;

    this.assignForm = this.fb.group({
      employeeId: ['', Validators.required],
      deadline: ['', Validators.required],
    });
  }

  loadEmployees() {
    this.projectService.getAllEmployees('').subscribe({
      next: (employees) => {
        this.employees = employees;
      },
      error: (error: any) => {
        this.toastr.error(error?.message);
      },
    });
  }

  onAssign() {
    const id = this.data?.id;
    const updateServiceTaskAssignmentInput = {
      id: id,
      employeeId: this.assignForm.value.employeeId || null,
      deadline: this.assignForm.value.deadline || null,
      startedAt: new Date() || null,
    };
    const CreateTaskTimelineInput = {
      assignmentId: id,
      actionType: 'Assigned',
      actorId: this.actorId,
      performerId: this.assignForm.value.employeeId,
      message: 'Task assigned',
    };
    this.salesOrderService
      .modifyTaskAssignment(
        id,
        updateServiceTaskAssignmentInput,
        CreateTaskTimelineInput
      )
      .subscribe({
        next: (data) => {
          this.toastr.success('Successfully assigned');
          this.dialogRef.close();
        },
        error: (error: any) => {
          this.toastr.error(error?.message);
        },
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
